import {
  IDefaultOption,
} from "apps/website/components/form/RadioButtons/RadioButtons.types";

export const MULTI_CAT_DISCOUNT_COUNT_TWO = 2;
export const MULTI_CAT_DISCOUNT_COUNT_THREE = 3;
export const MAX_CAT_COUNT = 4;

export type CatCount = 1 | 2 | 3 | 4;

export const CAT_COUNT_OPTIONS: IDefaultOption[] = [
  { value: "1", label: "1", component: "default" },
  { value: "2", label: "2", component: "default" },
  { value: "3", label: "3", component: "default" },
  { value: "4", label: "4", component: "default" },
];

export const hasMultiCatDiscount = (numCats: number): boolean =>
  numCats === MULTI_CAT_DISCOUNT_COUNT_TWO ||
  numCats === MULTI_CAT_DISCOUNT_COUNT_THREE ||
  numCats === MAX_CAT_COUNT;
